<template>
  <el-dialog
      title=""
      :visible.sync="visible"
      width="580px"
      center
      :show-close="false"
      custom-class="vip-experience-dialog"
      :before-close="handleClose">
    <div class="coupon-wrapper">
      <!-- 关闭按钮 -->
      <div class="close-btn" @click="handleClose">
        <i class="el-icon-close"></i>
      </div>

      <!-- 左侧主内容区 -->
      <div class="coupon-left">
        <!-- 装饰元素 -->
        <div class="decor-elements">
          <div class="decor-circle c1"></div>
          <div class="decor-circle c2"></div>
          <div class="decor-circle c3"></div>
          <div class="decor-star s1">&#10022;</div>
          <div class="decor-star s2">&#10022;</div>
        </div>

        <!-- 小标题 -->
        <div class="sub-title">{{ experienceData.description }} >></div>

        <!-- 主标题 -->
        <h2 class="main-title">SVIP体验券</h2>

        <!-- 领取按钮 -->
        <el-button
            class="receive-btn"
            :loading="receiving"
            @click="handleReceive">
          {{ receiving ? '领取中...' : '立即领取' }}
        </el-button>
      </div>

      <!-- 中间锯齿分割线 -->
      <div class="coupon-divider">
        <div class="circle-top"></div>
        <div class="dashed-line"></div>
        <div class="circle-bottom"></div>
      </div>

      <!-- 右侧体验券信息 -->
      <div class="coupon-right">
        <div class="right-label">免费领取</div>
        <div class="days-vertical">
          <span class="day-char">{{ experienceData.days || 3 }}</span>
          <span class="day-char">天</span>
        </div>
        <div class="coupon-no">SVIP体验券</div>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import {receiveVipExperience} from '@/api/index.js'

export default {
  name: 'VipExperienceDialog',

  props: {
    visible: {
      type: Boolean,
      default: false
    },
    experienceData: {
      type: Object,
      default: () => ({
        days: 3,
        description: '畅享全部VIP特权',
        expireTime: ''
      })
    }
  },

  data() {
    return {
      receiving: false
    }
  },

  methods: {
    handleClose() {
      this.$emit('update:visible', false)
      this.$emit('close')
    },

    async handleReceive() {
      if (this.receiving) return

      this.receiving = true
      try {
        const res = await receiveVipExperience()
        if (res.code === '0000') {
          this.$message.success('领取成功！VIP体验已开启')
          this.$emit('update:visible', false)
          this.$emit('receive-success', res.data)
        } else {
          this.$message.error(res.message || '领取失败，请稍后重试')
        }
      } catch (error) {
        console.error('领取VIP体验券失败:', error)
        this.$message.error('领取失败，请稍后重试')
      } finally {
        this.receiving = false
      }
    }
  }
}
</script>

<style lang="scss">
/* VIP体验券弹窗 - 券票样式 */
.vip-experience-dialog.el-dialog {
  background: transparent !important;
  border-radius: 12px !important;
  overflow: hidden;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.2);
  margin-top: 40vh !important;

  .el-dialog__header {
    display: none !important;
    padding: 0 !important;
    margin: 0 !important;
  }

  .el-dialog__body {
    padding: 0 !important;
    margin: 0 !important;
    background: transparent !important;
  }
}

.coupon-wrapper {
  display: flex;
  position: relative;
  min-height: 180px;
  border-radius: 12px;
  overflow: hidden;

  // 关闭按钮
  .close-btn {
    position: absolute;
    top: 10px;
    right: 10px;
    width: 28px;
    height: 28px;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    transition: all 0.3s ease;
    background: rgba(255, 255, 255, 0.2);
    z-index: 10;

    i {
      font-size: 14px;
      color: rgba(255, 255, 255, 0.9);
    }

    &:hover {
      background: rgba(255, 255, 255, 0.3);
      transform: rotate(90deg);
    }
  }

  // 左侧主内容区
  .coupon-left {
    flex: 1;
    background: linear-gradient(135deg, #ff6b6b 0%, #ee5a52 50%, #dc3545 100%);
    padding: 30px 35px;
    position: relative;
    display: flex;
    flex-direction: column;
    justify-content: center;
    overflow: hidden;

    // 光晕特效
    &::before {
      content: '';
      position: absolute;
      top: -50%;
      right: -30%;
      width: 200px;
      height: 200px;
      background: radial-gradient(circle, rgba(255, 255, 255, 0.2) 0%, transparent 70%);
      animation: glow 3s ease-in-out infinite;
    }

    &::after {
      content: '';
      position: absolute;
      bottom: -30%;
      left: -20%;
      width: 150px;
      height: 150px;
      background: radial-gradient(circle, rgba(255, 255, 255, 0.15) 0%, transparent 70%);
      animation: glow 3s ease-in-out infinite 1.5s;
    }

    // 装饰元素
    .decor-elements {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      pointer-events: none;
      overflow: hidden;

      // 圆形装饰
      .decor-circle {
        position: absolute;
        border-radius: 50%;
        border: 2px solid rgba(255, 255, 255, 0.15);
      }

      .c1 {
        width: 80px;
        height: 80px;
        top: -20px;
        right: 30px;
        animation: spin 12s linear infinite;
      }

      .c2 {
        width: 120px;
        height: 120px;
        bottom: -40px;
        right: 50px;
        border-style: dashed;
        animation: spin 18s linear infinite reverse;
      }

      .c3 {
        width: 50px;
        height: 50px;
        top: 45%;
        right: 15px;
        background: rgba(255, 255, 255, 0.08);
        animation: spin 10s linear infinite;
      }

      // 星星装饰
      .decor-star {
        position: absolute;
        font-size: 22px;
        color: rgba(255, 255, 255, 0.4);
        animation: twinkle 2s ease-in-out infinite;
      }

      .s1 {
        top: 20px;
        right: 90px;
      }

      .s2 {
        font-size: 16px;
        bottom: 25px;
        right: 20px;
        animation-delay: 1s;
      }
    }

    .sub-title {
      font-size: 14px;
      color: rgba(255, 255, 255, 0.9);
      font-weight: 500;
      margin-bottom: 8px;
      letter-spacing: 1px;
      position: relative;
      z-index: 2;
    }

    .main-title {
      font-size: 38px;
      font-weight: 800;
      color: #fff;
      margin: 0 0 20px;
      letter-spacing: 2px;
      text-shadow: 0 2px 10px rgba(0, 0, 0, 0.15);
      position: relative;
      z-index: 2;
    }

    .receive-btn {
      display: inline-flex;
      align-items: center;
      justify-content: center;
      width: fit-content;
      min-width: 140px;
      height: 42px;
      padding: 0 28px;
      background: #fff;
      border: none;
      border-radius: 25px;
      font-size: 15px;
      font-weight: 600;
      color: #dc3545;
      cursor: pointer;
      transition: all 0.3s ease;
      box-shadow: 0 4px 15px rgba(0, 0, 0, 0.15);
      position: relative;
      z-index: 2;

      &:hover {
        transform: translateY(-2px) scale(1.02);
        box-shadow: 0 6px 20px rgba(0, 0, 0, 0.2);
        background: #fff;
        color: #c82333;
      }
    }
  }

  // 中间锯齿分割
  .coupon-divider {
    width: 0;
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    z-index: 5;

    .circle-top,
    .circle-bottom {
      width: 16px;
      height: 16px;
      background: #8b1a1a;
      border-radius: 50%;
      position: absolute;
      box-shadow: none;
    }

    .circle-top {
      top: -8px;
    }

    .circle-bottom {
      bottom: -8px;
    }

    .dashed-line {
      position: absolute;
      top: 12px;
      bottom: 12px;
      width: 0;
      border-left: 2px dashed rgba(255, 255, 255, 0.3);
    }
  }

  // 右侧体验券信息
  .coupon-right {
    width: 110px;
    background: linear-gradient(180deg, #b71c1c 0%, #c62828 100%);
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 20px 15px;
    position: relative;

    .right-label {
      font-size: 12px;
      color: rgba(255, 255, 255, 0.7);
      margin-bottom: 10px;
      letter-spacing: 1px;
    }

    .days-vertical {
      display: flex;
      flex-direction: column;
      align-items: center;
      margin-bottom: 15px;

      .day-char {
        font-size: 36px;
        font-weight: 800;
        color: #fff;
        line-height: 1.1;
        text-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);

        &:last-child {
          font-size: 28px;
        }
      }
    }

    .coupon-no {
      font-size: 11px;
      color: rgba(255, 255, 255, 0.6);
      letter-spacing: 0.5px;
    }
  }
}

// 光晕动画
@keyframes glow {
  0%, 100% {
    opacity: 0.5;
    transform: scale(1);
  }
  50% {
    opacity: 1;
    transform: scale(1.1);
  }
}

// 旋转动画
@keyframes spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

// 闪烁动画
@keyframes twinkle {
  0%, 100% {
    opacity: 0.3;
    transform: scale(1);
  }
  50% {
    opacity: 1;
    transform: scale(1.2);
  }
}
</style>
